/*** type definitions ************************************************************************************************/

export const defaultBaseRequestParameters = {

    /**
     * The database schema to filter data and metadata for.
     */
    schema: 'DATA' as Schema,

    /**
     * The status to filter data for.
     */
    status: 'active' as Status,

    /**
     * The timestamp to filter data at.
     */
    timestamp: 'now' as string,

    /**
     * The timezone to filter data at.
     */
    timezone: 'Europe/Berlin' as string
};

export type BaseRequestParameters = Partial<typeof defaultBaseRequestParameters>;
